import { Component } from '@angular/core';


@Component({
    selector: 'app-privacy',
    imports: [],
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {

}
